module.exports = __webpack_public_path__ + "img/corneal-infiltrates-0.adfbaab0.jpg";